export enum SwapFlowView {
  Form = "form",
  Sign = "sign"
}

export interface SwapFlowState {
  view: SwapFlowView;
}

export type SwapFlowStateReducerAction = {
  type: "SET_VIEW";
  view: SwapFlowView;
};

export type SwapFlowStateContextValue = SwapFlowState;
export type SwapFlowDispatchContextValue =
  null | React.Dispatch<SwapFlowStateReducerAction>;
